import INotesAppState from '../interfaces/notesAppState';
import IAction from '../interfaces/action';
import TabName from '../interfaces/tabName';
import { actions } from './actions';

const initialState: INotesAppState = {
    notes: [],
    categories: [],
    allNotesListIsLoading: false,
    selectedPageId: null,
    visibleTabName: TabName.ALL,
    displayEditModal: false,
    editedCategoryName: '',
    selectedCategoryId: '',
    displayCreateModal: false,
    newCategoryName: '',
    displayFunctionsToolbar: false,
    selectedNotes: [],
    displayExportModal: false,
    displayShareModal: false,
    editedExportName: '',
    shareUrl: '',
    emailsToShareTo: '',
    displayNoteId: '',
    toastBarType: 'info',
    toastBarMessage: '',
    displayToastBar: false,
    exportModalButtonIsDisabled: true,
    editModalButtonIsDisabled: true,
    createModalButtonIsDisabled: true,
    hasNoSearchHits: false,
    expanded: false,
}

const reducer = (state = initialState, action: IAction): INotesAppState => {
    let notes = []
    let categories = []
    switch (action.type) {
        case actions.setDisplayNoteId:
            return {
                ...state, displayNoteId: action.payload
            }
        case actions.setSelectedNotes:
            let selectedNotes = [...state.selectedNotes]
            if (selectedNotes.indexOf(action.payload) < 0) {
                selectedNotes.push(action.payload)
            } else {
                selectedNotes = selectedNotes.filter(id => id !== action.payload)
            }
            return { ...state, selectedNotes }
        case actions.setSelectedCategoryId:
            return { ...state, selectedCategoryId: action.payload };
        case actions.setNewCategoryName:
            return { ...state, newCategoryName: action.payload };
        case actions.setShareUrl:
            return { ...state, shareUrl: action.payload };
        case actions.setEmailsToShareTo:
            return { ...state, emailsToShareTo: action.payload };
        case actions.setEditedCategoryName:
            return { ...state, editedCategoryName: action.payload };
        case actions.setExportName:
            return { ...state, editedExportName: action.payload };
        case actions.setAllNotes:
            notes = action.payload;
            return { ...state, notes };
        case actions.setNoSearchHits:
            return { ...state, hasNoSearchHits: action.payload };
        case actions.setExpandedState:
            return { ...state, expanded: action.payload };
        case actions.toggleFunctionsToolbar:
            return { ...state, displayFunctionsToolbar: !state.displayFunctionsToolbar };
        case actions.toggleExportModal:
            return { ...state, displayExportModal: !state.displayExportModal };
        case actions.toggleShareModal:
            return { ...state, displayShareModal: !state.displayShareModal };
        case actions.setAllCategories:
            categories = action.payload;
            return { ...state, categories };
        case actions.toggleEditModal:
            return { ...state, displayEditModal: !state.displayEditModal };
        case actions.toggleCreateModal:
            return { ...state, displayCreateModal: !state.displayCreateModal };
        case actions.toggleAllNotesListIsLoading:
            return { ...state, allNotesListIsLoading: !state.allNotesListIsLoading };
        case actions.setSelectedPageId:
            return { ...state, selectedPageId: action.payload };
        case actions.setVisibleTabName:
            return { ...state, visibleTabName: action.payload, selectedNotes: [] };
        case actions.setToastBarType:
            return { ...state, toastBarType: action.payload };
        case actions.setToastBarMessage:
            return { ...state, toastBarMessage: action.payload };
        case actions.toggleToastBar:
            return { ...state, displayToastBar: !state.displayToastBar };
        case actions.toggleExportModalButton:
            return { ...state, exportModalButtonIsDisabled: !state.exportModalButtonIsDisabled };
        case actions.toggleEditModalButton:
            return { ...state, editModalButtonIsDisabled: !state.editModalButtonIsDisabled };
        case actions.toggleCreateModalButton:
            return { ...state, createModalButtonIsDisabled: !state.createModalButtonIsDisabled };
        case actions.clearSelectedNotes:
            return { ...state, selectedNotes: [] };
        default:
            return state;
    }
}

export default reducer;